import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { FeatureToggleActions } from "../../redux/slices/feature-toggles";
import { useSelectorTyped } from "../../redux/store";
import { getEnvVars } from "../../config/env";
import { dispatchFetchPurposesIfEmpty } from "../../redux/slices/application-purpose";
import { useAuthUserInfo } from "../authentication/hooks";
import { headerActions } from "../header/redux";
import { useLocation } from "react-router-dom";
import { hasOktaTokenExpired } from "../authentication/data";
import { useGetFeatureToggleState } from "../../hooks/feature-toggles";

export default function useAppController() {
  const dispatch = useDispatch();
  const { microFrontends } = getEnvVars();
  const { getUser, setUserInfoIntoWindowObject } = useAuthUserInfo();
  const { pathname } = useLocation();
  const {
    email: userEmailPEV,
    name: userNamePEV,
    additionalInfo: userAdditionalInfoPEV,
  } = useSelectorTyped((state) => state.header.userInfo);
  const applicationPurposesPEV = useSelectorTyped((state) => state.applicationPurposesPEV);
  const isApiUnificationToggleEnabled = useGetFeatureToggleState("Neo_ApiPlatform_Unification");
  const isDisableRoutesToggleEnabled = useGetFeatureToggleState("Neo_ApiPlatform_Unification_DisableRoutes");
  const { unificationConfig, env } = getEnvVars();

  useEffect(function scrollWindowToTop() {
    if (!pathname.startsWith("/events")) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  useEffect(() => {
    if (userAdditionalInfoPEV.value) {
      setUserInfoIntoWindowObject({
        email: userEmailPEV.value,
        name: userNamePEV.value,
        employeeId: userAdditionalInfoPEV.value.employeeId,
      });
    }
  }, [userAdditionalInfoPEV.value]);

  useEffect(function onComponentMount() {
    window.addEventListener("focus", onWindowFocus);
    dispatch(FeatureToggleActions.fetchFeatureToggles());
    dispatchFetchPurposesIfEmpty(dispatch, applicationPurposesPEV);
    dispatch(headerActions.fetchUserInfo(getUser));
    dispatch(headerActions.fetchAdditionalUserInfo());
    dispatch(headerActions.fetchUiConfigs());

    return function onComponentUnmount() {
      window.removeEventListener("focus", onWindowFocus);
    };
  }, []);

  const onWindowFocus = () => {
    if (!hasOktaTokenExpired()) {
      dispatch(FeatureToggleActions.fetchFeatureToggles());
    }
  };

  const getProgressMsg = () => userEmailPEV.progress || userAdditionalInfoPEV.progress;
  const getErrorMsg = () => userEmailPEV.error || userAdditionalInfoPEV.error;

  const shouldRenderProgress = () => !!userEmailPEV.progress || !!userAdditionalInfoPEV.progress;
  const shouldRenderError = () => !!userEmailPEV.error || !!userAdditionalInfoPEV.error;

  return {
    microFrontends,
    isApiUnificationToggleEnabled,
    env,
    isDisableRoutesToggleEnabled,
    getProgressMsg,
    getErrorMsg,
    shouldRenderProgress,
    shouldRenderError,
    environmentConfig: { ...unificationConfig.environmentSpecificConfig },
  };
}
